import { omit } from 'lodash'
import baseApi from '@core/api'
import type {
    AssignWalletData,
    AssignWalletResponse,
    PaymentStatusData,
    PaymentStatusResponse,
    PreApprovalData,
    PreApprovalResponse,
    QrGenerateResponse,
    QrReadData,
    QrReadResponse,
    QrStatusData,
    QrStatusResponse,
    RefundQrReplyData,
    RefundQrReplyResponse,
    RefundReasonListResponse,
    RefundRequestData,
    RefundRequestPreCheckData,
    RefundRequestPreCheckResponse,
    RefundRequestResponse,
    RespondData,
    RespondResponse,
} from './PaymentApi.types'

const paymentApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        qrGenerate: builder.mutation<QrGenerateResponse, void>({
            query: () => ({
                url: '/qr/generate',
                method: 'GET',
            }),
        }),
        qrRead: builder.mutation<QrReadResponse, QrReadData>({
            query: data => ({
                url: '/qr/read',
                method: 'POST',
                body: data,
            }),
        }),
        qrStatus: builder.query<QrStatusResponse, QrStatusData>({
            query: data => ({
                url: '/qr/status',
                method: 'GET',
                params: data,
            }),
        }),
        assignWallet: builder.mutation<AssignWalletResponse, AssignWalletData>({
            query: data => ({
                url: `/payment/${data.paymentId}/assign-wallet`,
                method: 'PUT',
                body: omit(data, ['payment_id']),
            }),
        }),
        preApproval: builder.query<PreApprovalResponse, PreApprovalData>({
            query: data => ({
                url: `/payment/${data.paymentId}/pre-approval`,
                method: 'GET',
            }),
        }),
        respond: builder.mutation<RespondResponse, RespondData>({
            query: data => ({
                url: '/payment/respond',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: response =>
                response?.data.status !== 'complete' ? [] : ['WalletDetail'],
        }),
        paymentStatus: builder.query<PaymentStatusResponse, PaymentStatusData>({
            query: data => ({
                url: '/payment/status',
                method: 'GET',
                params: data,
            }),
        }),
        refundReasonList: builder.query<RefundReasonListResponse, undefined>({
            query: () => ({
                url: '/payment/refund/reason-list',
                method: 'GET',
            }),
        }),
        refundRequest: builder.mutation<
            RefundRequestResponse,
            RefundRequestData
        >({
            query: data => ({
                url: '/payment/refund/request',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: response =>
                response?.data.status !== 'open'
                    ? []
                    : ['BalanceHistoryDetail'],
        }),
        refundQrReply: builder.mutation<
            RefundQrReplyResponse,
            RefundQrReplyData
        >({
            query: data => ({
                url: '/payment/refund/qr-reply',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: (_r, error) =>
                error
                    ? []
                    : [
                          'BalanceHistoryDetail',
                          'WalletDetail',
                          'BalanceHistoryList',
                      ],
        }),
        refundRequestPreCheck: builder.query<
            RefundRequestPreCheckResponse,
            RefundRequestPreCheckData
        >({
            query: data => ({
                url: '/payment/refund/request/pre-check',
                method: 'GET',
                params: data,
            }),
        }),
    }),
})

export default paymentApi
